export default "__VITE_ASSET__CZVPXcLm__"